$ ->
  $('[data-toggle="tooltip"], a[rel=tooltip]').tooltip()
